<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { get } from 'lodash';

export default {
    name: 'Account',
    data() {
      return {
        success: null,
      };
    },
    computed: {
      ...mapState('user', [
        'user',
        'errors',
      ]),
      firstName: {
        get() {
          return get(this, 'user.firstName', null);
        },
        set(value) {
          const { user } = this;
          user.firstName = value;
          this.setUser(user);
        },
      },
      lastName: {
        get() {
          return get(this, 'user.lastName', null);
        },
        set(value) {
          const { user } = this;
          user.lastName = value;
          this.setUser(user);
        },
      },
      email: {
        get() {
          return get(this, 'user.email', null);
        },
        set(value) {
          const { user } = this;
          user.email = value;
          this.setUser(user);
        },
      },
      password: {
        get() {
          return get(this, 'user.password', null);
        },
        set(value) {
          const { user } = this;
          user.password = value && value.length > 0 ? value : null;
          this.setUser(user);
        },
      },
      currentPassword: {
        get() {
          return get(this, 'user.currentPassword', null);
        },
        set(value) {
          const { user } = this;
          user.currentPassword = value && value.length > 0 ? value : null;
          this.setUser(user);
        },
      },
    },
    methods: {
      ...mapMutations('user', [
        'setUser',
      ]),
      ...mapActions('user', [
        'fetchUserSave',
      ]),
      save() {
        this.fetchUserSave()
          .then(res => {
            this.success = res && res.id;

            setTimeout(() => {
              this.success = false;
            }, 3000);
          })
        ;
      }
    },
};
</script>
<template>
    <div id="myProfile" class="pb-5 bg-white">
        <div class="bg-white pt-5 pb-5">
            <h2 class="text-center">Moje Konta</h2>
        </div>
        <div class="text-center form">
            <div class="wrapper text-left">
                <div class="container d-flex flex-column">
                    <label for="firstName">Imię</label>
                    <input id="firstName" class="mb-3" v-model="firstName" />

                    <label for="lastName">Nazwisko</label>
                    <input id="lastName" class="mb-3" v-model="lastName" />

                    <label for="email">Email</label>
                    <input id="email" class="mb-3" v-model="email" />

                    <label for="password">Nowe Hasło</label>
                    <input id="password" class="mb-5" v-model="password" />

                    <label for="currentPassword" class="mt-5">Aktualne Hasło</label>
                    <input id="currentPassword" v-model="currentPassword" />

                    <div class="errors" v-if="errors.length > 0">
                        <div v-for="error in errors">{{ error }}</div>
                    </div>

                    <div class="alert-success mt-3 p-3" v-if="success">
                        Twój profil został zaktualizowany!
                    </div>
                    <div class="text-center">
                        <button @click="save">
                            ZAPISZ
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
